var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('section',{staticClass:"info-screen"},[_c('heading',{attrs:{"size":"m"}},[_vm._v(_vm._s(_vm.$i18n.t("errorHeading")))]),_c('div',{staticClass:"error"},[_c('span',{staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.$i18n.t("errorDescription")))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }